module.exports = __webpack_public_path__ + "img/icon-off.png";